import Button from "../Button";
import Icon from "../Icon";
import Title from "../Title";
import Image from "../Image";

interface UseCaseVideoPanelProps {
  infoIconClick: () => void;
  title: string;
  imageClick: () => void;
  image: string;
  bottomButtons?: ButtonProps[];
}

const UseCaseVideoPanel = ({
  infoIconClick,
  title,
  image,
  imageClick,
  bottomButtons,
}: UseCaseVideoPanelProps) => (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      zIndex: 2,
    }}
  >
    <div
      onClick={infoIconClick}
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "absolute",
        right: "99.92px",
        bottom: "822.92px",
        width: "81.081px",
        height: "81.081px",
        flexShrink: 0,
        borderRadius: "15px",
        background: "rgba(255, 255, 255, 0.21)",
        backdropFilter: "blur(12px)",
        zIndex: 3,
      }}
    >
      <Icon type="info" color="white" />
    </div>
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        position: "absolute",
        bottom: "363.19px",
        right: "75px",
      }}
      onClick={imageClick}
    >
      <Title
        style={{
          fontSize: "50px",
          fontWeight: 500,
          lineHeight: "100%",
          letterSpacing: "1.5px",
          marginBottom: "16px",
        }}
        type="video-journey-template"
        text={title}
      />
      <Image imagePath={image} />
    </div>
    <div
      style={{
        display: "flex",
        position: "absolute",
        bottom: "120px",
        right: "100px",
        gap: "16px",
      }}
    >
      {bottomButtons &&
        bottomButtons.map((button, index) => (
          <Button key={index} {...button} />
        ))}
    </div>
  </div>
);

export default UseCaseVideoPanel;
